(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function startRotator(root) {
      var items = root.querySelectorAll('.announcement__item');
      if (items.length < 2) return;

      var index = 0;

      window.setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, 4800);
    }

    // The header offsets itself by the height of this bar.
    function publishHeight(bar) {
      document.documentElement.style.setProperty(
        '--announcement-h',
        bar.offsetHeight + 'px'
      );
    }

    function init(scope) {
      var bars = (scope || document).querySelectorAll('[data-announcement]');

      Array.prototype.forEach.call(bars, function (bar) {
        startRotator(bar);
        publishHeight(bar);

        window.addEventListener('resize', function () {
          publishHeight(bar);
        }, { passive: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function init(scope) {
      var root = (scope || document).querySelector('[data-collection]');
      if (!root || root.dataset.collectionBound === 'true') return;
      root.dataset.collectionBound = 'true';

      var form = root.querySelector('[data-facet-form]');
      var sectionId = root.getAttribute('data-section-id');
      var timer;

      function buildUrl() {
        var params = new URLSearchParams();

        if (form) {
          new FormData(form).forEach(function (value, key) {
            if (value !== '') params.append(key, value);
          });
        }

        return window.location.pathname + '?' + params.toString();
      }

      function render(url, append) {
        root.classList.add('is-loading');

        return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var fresh = parsed.querySelector('[data-facet-results]');
            var current = root.querySelector('[data-facet-results]');
            if (!fresh || !current) return;

            if (append) {
              var freshGrid = fresh.querySelector('[data-grid]');
              var currentGrid = current.querySelector('[data-grid]');
              var more = current.querySelector('.coll__more');

              if (freshGrid && currentGrid) {
                while (freshGrid.firstElementChild) {
                  currentGrid.appendChild(freshGrid.firstElementChild);
                }
              }

              var freshMore = fresh.querySelector('.coll__more');
              if (more) more.remove();
              if (freshMore) current.appendChild(freshMore);
            } else {
              current.innerHTML = fresh.innerHTML;

              var freshBar = parsed.querySelector('[data-facet-form]');
              var currentBar = root.querySelector('[data-facet-form]');
              if (freshBar && currentBar) currentBar.innerHTML = freshBar.innerHTML;

              var freshActive = parsed.querySelector('.coll__active');
              var currentActive = root.querySelector('.coll__active');
              if (currentActive && freshActive) {
                currentActive.innerHTML = freshActive.innerHTML;
              } else if (currentActive) {
                currentActive.remove();
              }
            }

            if (window.PlantzMotion) window.PlantzMotion.init(root);
          })
          .finally(function () {
            root.classList.remove('is-loading');
          });
      }

      if (form) {
        form.addEventListener('change', function () {
          window.clearTimeout(timer);
          timer = window.setTimeout(function () {
            var url = buildUrl();
            window.history.replaceState({}, '', url);
            render(url, false);
          }, 200);
        });

        form.addEventListener('submit', function (event) {
          event.preventDefault();
        });
      }

      root.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-filter-open]');
        if (toggle) {
          var facets = root.querySelector('[data-facets]');
          if (facets) facets.classList.toggle('is-open');
          return;
        }

        var more = event.target.closest('[data-load-more]');
        if (more) {
          event.preventDefault();
          more.classList.add('is-loading');
          render(more.getAttribute('href'), true);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  (function () {
    var CAPTCHA_MAX_ATTEMPTS = 24;
    var CAPTCHA_RETRY_DELAY_MS = 250;

    function setCaptchaFeedback(form, message) {
      var feedback = form.querySelector('[data-contact-captcha-feedback]');
      if (!feedback) return;
      if (!message) {
        feedback.hidden = true;
        feedback.textContent = '';
        return;
      }
      feedback.textContent = message;
      feedback.hidden = false;
    }

    function getCaptchaApi() {
      var captcha = window.Shopify && window.Shopify.captcha;
      if (!captcha || typeof captcha.protect !== 'function') return null;
      return captcha;
    }

    function clearCaptchaRetryTimer(form) {
      if (!form.__contactCaptchaRetryTimer) return;
      window.clearTimeout(form.__contactCaptchaRetryTimer);
      form.__contactCaptchaRetryTimer = null;
    }

    function protectWhenReady(form, attempt) {
      if (!document.documentElement.contains(form)) return;
      if (form.dataset.captchaProtectState === 'done') return;

      var captcha = getCaptchaApi();
      if (captcha) {
        clearCaptchaRetryTimer(form);
        captcha.protect(form);
        form.dataset.captchaProtectState = 'done';
        setCaptchaFeedback(form, '');
        return;
      }

      if (attempt >= CAPTCHA_MAX_ATTEMPTS) {
        form.dataset.captchaProtectState = 'failed';
        setCaptchaFeedback(
          form,
          'We konden de spamcontrole niet starten. Ververs de pagina en probeer opnieuw.'
        );
        return;
      }

      form.__contactCaptchaRetryTimer = window.setTimeout(function () {
        protectWhenReady(form, attempt + 1);
      }, CAPTCHA_RETRY_DELAY_MS);
    }

    function wireCaptcha(form) {
      if (form.dataset.captchaProtectState === 'done') return;
      if (form.dataset.captchaProtectState === 'pending') return;
      form.dataset.captchaProtectState = 'pending';
      setCaptchaFeedback(form, '');
      protectWhenReady(form, 0);
    }

    function bindSubmitFeedbackReset(form) {
      if (form.dataset.captchaSubmitBound === 'true') return;
      form.dataset.captchaSubmitBound = 'true';

      form.addEventListener('submit', function () {
        setCaptchaFeedback(form, '');
      });
    }

    function init(scope) {
      var root = scope || document;
      var forms = root.querySelectorAll('form.contact-page__form');

      Array.prototype.forEach.call(forms, function (form) {
        clearCaptchaRetryTimer(form);
        if (form.dataset.captchaProtectState === 'failed') {
          delete form.dataset.captchaProtectState;
        }
        wireCaptcha(form);
        bindSubmitFeedbackReset(form);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var openers = {
      '[data-menu-open]': '[data-mobile-nav]',
      '[data-search-open]': '[data-search-panel]',
    };

    function openPanel(panel) {
      if (!panel || panel.open) return;
      panel.showModal();
      document.body.classList.add('is-locked');

      var input = panel.querySelector('[data-search-input]');
      if (input) window.setTimeout(function () { input.focus(); }, 120);
    }

    function closePanel(panel) {
      if (!panel || !panel.open) return;
      panel.close();
    }

    Object.keys(openers).forEach(function (trigger) {
      document.addEventListener('click', function (event) {
        var button = event.target.closest(trigger);
        if (!button) return;
        openPanel(document.querySelector(openers[trigger]));
      });
    });

    document.addEventListener('click', function (event) {
      var closer = event.target.closest('[data-panel-close]');
      if (closer) {
        closePanel(closer.closest('dialog'));
        return;
      }

      // Clicking the backdrop area of a dialog closes it.
      var dialog = event.target.closest('dialog.panel');
      if (dialog && event.target === dialog) closePanel(dialog);
    });

    document.addEventListener('close', function (event) {
      if (!event.target.classList || !event.target.classList.contains('panel')) return;
      if (!document.querySelector('dialog[open]')) {
        document.body.classList.remove('is-locked');
      }
    }, true);

    // Close the mobile panel when the viewport grows past the breakpoint.
    window.matchMedia('(min-width: 750px)').addEventListener('change', function (event) {
      if (event.matches) closePanel(document.querySelector('[data-mobile-nav]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herbarium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeDropdown(dropdown, returnFocus) {
      if (!dropdown || !dropdown.classList.contains('is-open')) return;
      dropdown.classList.remove('is-open');
      var trigger = dropdown.querySelector('[data-herb-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus && trigger) trigger.focus();
    }

    function closeAllDropdowns(except) {
      document.querySelectorAll('[data-herb-dropdown].is-open').forEach(function (dropdown) {
        if (except && dropdown === except) return;
        closeDropdown(dropdown, false);
      });
    }

    function getEnabledOptions(dropdown) {
      return Array.prototype.slice.call(dropdown.querySelectorAll('[data-herb-option]')).filter(function (option) {
        return !option.disabled;
      });
    }

    function setSelectedOption(dropdown, option) {
      if (!dropdown || !option || option.disabled) return;

      var input = dropdown.querySelector('[data-herb-variant-input]');
      var label = dropdown.querySelector('[data-herb-selected-label]');
      var options = dropdown.querySelectorAll('[data-herb-option]');
      var card = dropdown.closest('.herb__card');
      var image = card && card.querySelector('[data-herb-image]');
      var imageSrc = option.getAttribute('data-variant-image-src');
      var imageSrcset = option.getAttribute('data-variant-image-srcset');
      var imageAlt = option.getAttribute('data-variant-image-alt');

      if (input) input.value = option.getAttribute('data-variant-id');
      if (label) label.textContent = option.getAttribute('data-variant-label') || option.textContent.trim();
      if (image && imageSrc) {
        image.setAttribute('src', imageSrc);
        if (imageSrcset) image.setAttribute('srcset', imageSrcset);
        if (imageAlt !== null) image.setAttribute('alt', imageAlt);
      }

      options.forEach(function (item) {
        var selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }

    function focusCurrentOption(dropdown) {
      var selected = dropdown.querySelector('[data-herb-option].is-selected:not(:disabled)');
      var fallback = getEnabledOptions(dropdown)[0];
      var target = selected || fallback;
      if (target) target.focus();
    }

    function moveOptionFocus(dropdown, direction) {
      var options = getEnabledOptions(dropdown);
      if (!options.length) return;
      var current = document.activeElement;
      var index = options.indexOf(current);
      if (index === -1) index = direction > 0 ? -1 : 0;
      var next = (index + direction + options.length) % options.length;
      options[next].focus();
    }

    function openDropdown(dropdown) {
      closeAllDropdowns(dropdown);
      dropdown.classList.add('is-open');
      var trigger = dropdown.querySelector('[data-herb-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(function () {
        focusCurrentOption(dropdown);
      });
    }

    function bindDropdown(dropdown) {
      if (!dropdown || dropdown.dataset.herbDropdownBound === 'true') return;
      dropdown.dataset.herbDropdownBound = 'true';

      var trigger = dropdown.querySelector('[data-herb-trigger]');
      var menu = dropdown.querySelector('[data-herb-menu]');

      if (!trigger || !menu) return;

      trigger.addEventListener('click', function () {
        if (dropdown.classList.contains('is-open')) {
          closeDropdown(dropdown, false);
          return;
        }
        openDropdown(dropdown);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown') {
          event.preventDefault();
          openDropdown(dropdown);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          openDropdown(dropdown);
          var options = getEnabledOptions(dropdown);
          if (options.length) options[options.length - 1].focus();
        }
      });

      menu.addEventListener('click', function (event) {
        var option = event.target.closest('[data-herb-option]');
        if (!option || option.disabled) return;
        setSelectedOption(dropdown, option);
        closeDropdown(dropdown, true);
      });

      menu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDropdown(dropdown, true);
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          moveOptionFocus(dropdown, 1);
          return;
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          moveOptionFocus(dropdown, -1);
          return;
        }

        if (event.key === 'Home') {
          event.preventDefault();
          var first = getEnabledOptions(dropdown)[0];
          if (first) first.focus();
          return;
        }

        if (event.key === 'End') {
          event.preventDefault();
          var options = getEnabledOptions(dropdown);
          if (options.length) options[options.length - 1].focus();
          return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
          var option = document.activeElement && document.activeElement.closest('[data-herb-option]');
          if (!option || option.disabled) return;
          event.preventDefault();
          setSelectedOption(dropdown, option);
          closeDropdown(dropdown, true);
          return;
        }

        if (event.key === 'Tab') closeDropdown(dropdown, false);
      });

      var initial = dropdown.querySelector('[data-herb-option].is-selected') || getEnabledOptions(dropdown)[0];
      if (initial) setSelectedOption(dropdown, initial);
    }

    function init(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-herb-dropdown]').forEach(bindDropdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-herb-dropdown]')) return;
      closeAllDropdowns(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAllDropdowns(null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-glasshouse"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function setText(root, selector, value) {
      var node = root.querySelector(selector);
      if (node) node.textContent = value;
    }

    function startCountdown(root) {
      var end = parseInt(root.getAttribute('data-countdown-end'), 10) || 0;
      var start = parseInt(root.getAttribute('data-countdown-start'), 10) || 0;
      var clock = root.querySelector('[data-countdown-clock]');
      var elapsed = root.querySelector('[data-countdown-elapsed]');
      var timer = null;

      if (!end) return;

      function tick() {
        var now = Math.floor(Date.now() / 1000);
        var left = end - now;

        // A sale that runs out while the page is open should leave with it.
        if (left <= 0) {
          window.clearInterval(timer);
          root.hidden = true;
          return;
        }

        if (clock) {
          setText(clock, '[data-countdown-days]', String(Math.floor(left / 86400)));
          setText(clock, '[data-countdown-hours]', pad(Math.floor((left % 86400) / 3600)));
          setText(clock, '[data-countdown-minutes]', pad(Math.floor((left % 3600) / 60)));
          setText(clock, '[data-countdown-seconds]', pad(left % 60));
        }

        if (elapsed && end > start) {
          var ratio = (now - start) / (end - start);
          ratio = Math.min(1, Math.max(0, ratio));
          elapsed.style.setProperty('--elapsed', (ratio * 100).toFixed(2) + '%');
        }
      }

      tick();
      timer = window.setInterval(tick, 1000);
    }

    function init(scope) {
      var roots = (scope || document).querySelectorAll('[data-countdown]');
      Array.prototype.forEach.call(roots, startCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(index, length) {
      if (!length) return 0;
      if (index < 0) return length - 1;
      if (index >= length) return 0;
      return index;
    }

    function shuffle(items) {
      var clone = items.slice();

      for (var index = clone.length - 1; index > 0; index -= 1) {
        var swapIndex = Math.floor(Math.random() * (index + 1));
        var value = clone[index];
        clone[index] = clone[swapIndex];
        clone[swapIndex] = value;
      }

      return clone;
    }

    function readDelay(root) {
      var delay = parseInt(root.getAttribute('data-home-reviews-delay'), 10);
      if (isNaN(delay) || delay < 1200) return 5000;
      return delay;
    }

    function clearTimer(state) {
      if (!state.timerId) return;
      window.clearInterval(state.timerId);
      state.timerId = null;
    }

    function updateDots(state) {
      state.dots.forEach(function (dot, index) {
        var active = index === state.index;
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function updateSlidesA11y(state) {
      state.slides.forEach(function (slide, index) {
        slide.setAttribute('aria-hidden', index === state.index ? 'false' : 'true');
      });
    }

    function goTo(state, nextIndex, instant) {
      if (!state.slideCount) return;

      state.index = clamp(nextIndex, state.slideCount);

      if (instant || state.reduceMotion) {
        state.track.classList.add('is-instant');
      } else {
        state.track.classList.remove('is-instant');
      }

      state.track.style.transform = 'translate3d(' + state.index * -100 + '%, 0, 0)';
      updateDots(state);
      updateSlidesA11y(state);

      if (state.track.classList.contains('is-instant')) {
        window.requestAnimationFrame(function () {
          state.track.classList.remove('is-instant');
        });
      }
    }

    function canAutoplay(state) {
      return state.slideCount > 1 && !state.reduceMotion && state.isVisible && !document.hidden;
    }

    function syncAutoplay(state) {
      clearTimer(state);
      if (!canAutoplay(state)) return;
      state.timerId = window.setInterval(function () {
        goTo(state, state.index + 1, false);
      }, state.delay);
    }

    function teardown(root) {
      var state = root.__homeReviewsState;
      if (!state) return;

      clearTimer(state);
      document.removeEventListener('visibilitychange', state.onVisibilityChange);

      if (state.dotsRoot && state.onDotsClick) {
        state.dotsRoot.removeEventListener('click', state.onDotsClick);
      }

      if (state.reduceMotionQuery && state.onReduceMotionChange) {
        if (typeof state.reduceMotionQuery.removeEventListener === 'function') {
          state.reduceMotionQuery.removeEventListener('change', state.onReduceMotionChange);
        } else if (typeof state.reduceMotionQuery.removeListener === 'function') {
          state.reduceMotionQuery.removeListener(state.onReduceMotionChange);
        }
      }

      if (state.visibilityObserver) {
        state.visibilityObserver.disconnect();
      }

      root.__homeReviewsState = null;
    }

    function buildRandomSlides(root) {
      var track = root.querySelector('[data-home-reviews-track]');
      var dotsRoot = root.querySelector('[data-home-reviews-dots]');
      var templates = Array.prototype.slice.call(root.querySelectorAll('[data-home-review-template]'));

      if (!track || !dotsRoot || !templates.length) return null;

      var picks = shuffle(templates).slice(0, Math.min(5, templates.length));
      var slidesFragment = document.createDocumentFragment();
      var dotsFragment = document.createDocumentFragment();
      var sectionId = root.getAttribute('data-home-reviews-id') || 'home-reviews';
      var dots = [];
      var slides = [];

      picks.forEach(function (template, index) {
        var slide = template.content.firstElementChild.cloneNode(true);
        var slideId = 'home-review-' + sectionId + '-' + (index + 1);

        slide.id = slideId;
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', 'Review ' + (index + 1) + ' van ' + picks.length);
        slides.push(slide);
        slidesFragment.appendChild(slide);

        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hreviews__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Ga naar review ' + (index + 1));
        dot.setAttribute('aria-controls', slideId);
        dot.setAttribute('data-home-review-dot', String(index));
        dots.push(dot);
        dotsFragment.appendChild(dot);
      });

      track.innerHTML = '';
      dotsRoot.innerHTML = '';
      track.appendChild(slidesFragment);
      dotsRoot.appendChild(dotsFragment);

      return {
        track: track,
        dotsRoot: dotsRoot,
        slides: slides,
        dots: dots,
        slideCount: slides.length,
      };
    }

    function observeVisibility(root, state) {
      if (!('IntersectionObserver' in window)) return null;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== root) return;
            state.isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
            syncAutoplay(state);
          });
        },
        {
          threshold: [0, 0.35, 0.75],
        }
      );

      observer.observe(root);
      return observer;
    }

    function initRoot(root) {
      teardown(root);

      var built = buildRandomSlides(root);
      if (!built || !built.slideCount) return;

      var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var state = {
        root: root,
        track: built.track,
        dotsRoot: built.dotsRoot,
        slides: built.slides,
        dots: built.dots,
        slideCount: built.slideCount,
        index: 0,
        delay: readDelay(root),
        timerId: null,
        isVisible: true,
        reduceMotion: reduceMotionQuery.matches,
        reduceMotionQuery: reduceMotionQuery,
      };

      state.onDotsClick = function (event) {
        var dot = event.target.closest('[data-home-review-dot]');
        if (!dot) return;
        var targetIndex = parseInt(dot.getAttribute('data-home-review-dot'), 10);
        if (isNaN(targetIndex)) return;
        goTo(state, targetIndex, false);
        syncAutoplay(state);
      };

      state.onVisibilityChange = function () {
        syncAutoplay(state);
      };

      state.onReduceMotionChange = function (event) {
        state.reduceMotion = event.matches;
        state.track.classList.toggle('is-motion-off', state.reduceMotion);
        syncAutoplay(state);
      };

      state.dotsRoot.addEventListener('click', state.onDotsClick);
      document.addEventListener('visibilitychange', state.onVisibilityChange);

      if (typeof reduceMotionQuery.addEventListener === 'function') {
        reduceMotionQuery.addEventListener('change', state.onReduceMotionChange);
      } else if (typeof reduceMotionQuery.addListener === 'function') {
        reduceMotionQuery.addListener(state.onReduceMotionChange);
      }

      state.visibilityObserver = observeVisibility(root, state);
      state.track.classList.toggle('is-motion-off', state.reduceMotion);
      goTo(state, 0, true);
      syncAutoplay(state);
      root.__homeReviewsState = state;
    }

    function init(scope) {
      var roots = (scope || document).querySelectorAll('[data-home-reviews]');
      Array.prototype.forEach.call(roots, function (root) {
        initRoot(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll('[data-home-reviews]');
      Array.prototype.forEach.call(roots, function (root) {
        teardown(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-greenhouse"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fallbackCopy(text) {
      return new Promise(function (resolve, reject) {
        var input = document.createElement('input');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();

        var copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }

        document.body.removeChild(input);

        if (copied) {
          resolve();
        } else {
          reject(new Error('copy-failed'));
        }
      });
    }

    function copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return fallbackCopy(text);
    }

    function setFeedback(card, message) {
      var feedback = card.querySelector('[data-copy-feedback]');
      if (feedback) feedback.textContent = message;
    }

    function init(scope) {
      var cards = (scope || document).querySelectorAll('[data-newsletter-discount]');

      Array.prototype.forEach.call(cards, function (card) {
        if (card.dataset.copyBound === 'true') return;
        card.dataset.copyBound = 'true';

        card.addEventListener('click', function (event) {
          var button = event.target.closest('[data-copy-discount]');
          if (!button) return;

          event.preventDefault();

          var code = button.getAttribute('data-discount-code') || '';
          var label = button.querySelector('[data-copy-label]');
          var defaultLabel = button.getAttribute('data-copy-default') || 'Kopieer code';
          var successLabel = button.getAttribute('data-copy-success') || 'Gekopieerd';
          var errorLabel = button.getAttribute('data-copy-error') || 'Handmatig kopieren';

          if (!code) {
            setFeedback(card, 'Geen kortingscode beschikbaar.');
            return;
          }

          copyToClipboard(code)
            .then(function () {
              if (label) label.textContent = successLabel;
              setFeedback(card, 'Kortingscode gekopieerd.');
            })
            .catch(function () {
              if (label) label.textContent = errorLabel;
              setFeedback(card, 'Kopieren lukte niet. Gebruik de code handmatig.');
            })
            .finally(function () {
              window.setTimeout(function () {
                if (label) label.textContent = defaultLabel;
              }, 1800);
            });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function init(scope) {
      var root = (scope || document).querySelector('[data-product-root]');
      if (!root || root.dataset.pdpBound === 'true') return;
      root.dataset.pdpBound = 'true';

      var sectionId = root.getAttribute('data-section-id');
      var productUrl = root.getAttribute('data-product-url');
      var simStockMemory = window.__pdpSimStockMemory || {};
      var simStockStepped = false;
      window.__pdpSimStockMemory = simStockMemory;

      function randomBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      function getSimStockKey() {
        var productId = root.getAttribute('data-product-id');
        var productHandle = root.getAttribute('data-product-handle');
        return 'plantspiral:sim-stock:' + (productId || productHandle || 'default');
      }

      function readStoredStock(key) {
        var raw = null;

        try {
          raw = window.localStorage.getItem(key);
        } catch (error) {
          raw = simStockMemory[key];
        }

        var parsed = parseInt(raw, 10);
        if (!Number.isFinite(parsed)) return null;
        return Math.max(12, Math.min(22, parsed));
      }

      function writeStoredStock(key, value) {
        simStockMemory[key] = String(value);

        try {
          window.localStorage.setItem(key, String(value));
        } catch (error) {
          // localStorage can be blocked by privacy settings, memory fallback stays active.
        }
      }

      function renderSimulatedStock(advanceOnVisit) {
        var stockNode = root.querySelector('[data-sim-stock-text]');
        if (!stockNode) return;

        var key = getSimStockKey();
        var current = readStoredStock(key);

        if (current === null) {
          current = randomBetween(12, 22);
          writeStoredStock(key, current);
        } else if (advanceOnVisit && simStockStepped === false) {
          current = Math.max(12, current - randomBetween(3, 6));
          writeStoredStock(key, current);
        }

        if (advanceOnVisit && simStockStepped === false) simStockStepped = true;
        stockNode.textContent = 'Nog ' + current + ' op voorraad';
      }

      /* Quantity stepper */
      root.addEventListener('click', function (event) {
        var input = root.querySelector('[data-pdp-qty]');
        if (!input) return;

        if (event.target.closest('[data-pdp-qty-up]')) {
          input.value = (parseInt(input.value, 10) || 1) + 1;
        } else if (event.target.closest('[data-pdp-qty-down]')) {
          input.value = Math.max((parseInt(input.value, 10) || 1) - 1, 1);
        }
      });

      var variants = [];

      try {
        var json = root.querySelector('[data-variant-json]');
        if (json) variants = JSON.parse(json.textContent);
      } catch (error) {
        variants = [];
      }

      renderSimulatedStock(true);

      function findVariant(selection) {
        for (var i = 0; i < variants.length; i++) {
          var options = variants[i].options || [];
          var match = options.length === selection.length;

          for (var j = 0; match && j < options.length; j++) {
            if (options[j] !== selection[j]) match = false;
          }

          if (match) return variants[i];
        }

        return null;
      }

      /* Variant selection: let Liquid render the new state. */
      root.addEventListener('change', function (event) {
        var input = event.target.closest('[data-option-input]');
        if (!input) return;

        var checked = Array.prototype.slice.call(
          root.querySelectorAll('[data-option-input]:checked')
        );

        checked.sort(function (a, b) {
          return a.getAttribute('data-option-position') - b.getAttribute('data-option-position');
        });

        var selection = checked.map(function (node) {
          return node.value;
        });

        var variant = findVariant(selection);
        var info = root.querySelector('[data-product-info]');

        if (!variant) {
          var button = root.querySelector('[data-add-button]');
          if (button) {
            button.disabled = true;
            button.querySelector('span').textContent = 'Niet beschikbaar';
          }
          return;
        }

        if (info) info.classList.add('is-updating');

        fetch(productUrl + '?variant=' + variant.id + '&section_id=' + sectionId)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var fresh = parsed.querySelector('[data-product-info]');
            var current = root.querySelector('[data-product-info]');
            if (!fresh || !current) return;

            current.innerHTML = fresh.innerHTML;
            renderSimulatedStock(false);

            /**
             * The buy bar sits outside the panel, so it has to be swapped from
             * the same response. Without this it keeps showing the price and
             * photo of the variant the visitor moved away from.
             */
            var freshBar = parsed.querySelector('[data-buybar-info]');
            var currentBar = document.querySelector('[data-buybar-info]');
            if (freshBar && currentBar) currentBar.innerHTML = freshBar.innerHTML;

            // The observed button was just replaced, so re-arm the buy bar.
            watchAddButton();

            // Restore focus on the option the visitor just picked.
            var position = input.getAttribute('data-option-position');
            var candidates = current.querySelectorAll(
              '[data-option-input][data-option-position="' + position + '"]'
            );

            Array.prototype.forEach.call(candidates, function (node) {
              if (node.value === input.value) node.focus();
            });

            var next = new URL(window.location.href);
            next.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', next.toString());
            showVariantMedia(variant.featured_media ? variant.featured_media.id : null);
          })
          .finally(function () {
            var panel = root.querySelector('[data-product-info]');
            if (panel) panel.classList.remove('is-updating');
          });
      });

      /* ------------------------------------------------------------------
       * Gallery
       * ---------------------------------------------------------------- */

      var stage = root.querySelector('[data-gallery-stage]');
      var frames = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-frame]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
      var prev = root.querySelector('[data-gallery-prev]');
      var next = root.querySelector('[data-gallery-next]');
      var activeIndex = 0;

      function goTo(index) {
        if (!stage || !frames.length) return;
        activeIndex = Math.min(Math.max(index, 0), frames.length - 1);
        stage.scrollTo({ left: frames[activeIndex].offsetLeft - stage.offsetLeft });
      }

      function markActive(index) {
        activeIndex = index;

        thumbs.forEach(function (thumb, at) {
          thumb.setAttribute('aria-selected', at === index ? 'true' : 'false');
        });

        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === frames.length - 1;
      }

      if (stage && frames.length) {
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            goTo(parseInt(thumb.getAttribute('data-gallery-thumb'), 10));
          });
        });

        if (prev) prev.addEventListener('click', function () { goTo(activeIndex - 1); });
        if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); });

        // Swiping is as valid as clicking, so the active state follows the scroll.
        if ('IntersectionObserver' in window) {
          var galleryObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) markActive(frames.indexOf(entry.target));
              });
            },
            { root: stage, threshold: 0.6 }
          );

          frames.forEach(function (frame) { galleryObserver.observe(frame); });
        }

        markActive(0);
      }

      function showVariantMedia(mediaId) {
        if (!mediaId) return;
        var frame = root.querySelector('[data-media-id="' + mediaId + '"]');
        if (frame) {
          var index = frames.indexOf(frame);
          goTo(index);
          markActive(index);
        }
      }

      var preferredMediaId = root.getAttribute('data-preferred-media-id');
      var initialVariantInput = root.querySelector('[data-variant-id]');
      var initialVariant = initialVariantInput
        ? variants.find(function (variant) {
            return String(variant.id) === initialVariantInput.value;
          })
        : null;

      if (preferredMediaId) {
        showVariantMedia(preferredMediaId);
      } else if (initialVariant && initialVariant.featured_media) {
        showVariantMedia(initialVariant.featured_media.id);
      }

      /* ------------------------------------------------------------------
       * Full-size viewer
       * ---------------------------------------------------------------- */

      var dialog = document.querySelector('[data-zoom-dialog]');
      var zoomImage = dialog && dialog.querySelector('[data-zoom-image]');
      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-zoom]'));

      if (dialog && zoomImage && triggers.length && typeof dialog.showModal === 'function') {
        var zoomCount = dialog.querySelector('[data-zoom-count]');
        var zoomCaption = dialog.querySelector('[data-zoom-caption]');
        var zoomPrev = dialog.querySelector('[data-zoom-prev]');
        var zoomNext = dialog.querySelector('[data-zoom-next]');
        var zoomIndex = 0;

        function showPhoto(index) {
          zoomIndex = Math.min(Math.max(index, 0), triggers.length - 1);

          var trigger = triggers[zoomIndex];
          var thumbnail = trigger.querySelector('img');
          var caption = thumbnail ? thumbnail.alt : '';

          /**
           * Full-size files are large enough that the swap is visible, and a
           * photo half replaced by the next one looks broken. Fading through
           * the change costs nothing and reads as deliberate. Reopening the
           * same photo sets the same source, which fires no load event, so
           * that case must not start a fade it would never come out of.
           */
          var source = trigger.getAttribute('data-gallery-zoom');

          if (zoomImage.getAttribute('src') !== source) {
            dialog.classList.add('is-swapping');
            zoomImage.src = source;
            if (zoomImage.complete) dialog.classList.remove('is-swapping');
          }

          zoomImage.alt = caption;

          if (zoomCaption) zoomCaption.textContent = caption;
          if (zoomCount) zoomCount.textContent = zoomIndex + 1 + ' / ' + triggers.length;
          if (zoomPrev) zoomPrev.disabled = zoomIndex === 0;
          if (zoomNext) zoomNext.disabled = zoomIndex === triggers.length - 1;
        }

        ['load', 'error'].forEach(function (name) {
          zoomImage.addEventListener(name, function () {
            dialog.classList.remove('is-swapping');
          });
        });

        root.addEventListener('click', function (event) {
          var trigger = event.target.closest('[data-gallery-zoom]');
          if (!trigger) return;

          showPhoto(triggers.indexOf(trigger));
          dialog.showModal();
        });

        if (zoomPrev) {
          zoomPrev.addEventListener('click', function () { showPhoto(zoomIndex - 1); });
        }

        if (zoomNext) {
          zoomNext.addEventListener('click', function () { showPhoto(zoomIndex + 1); });
        }

        dialog.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') showPhoto(zoomIndex - 1);
          if (event.key === 'ArrowRight') showPhoto(zoomIndex + 1);
        });

        // Anywhere off the photo closes, which is where people click to escape.
        // The arrows sit off the photo too, so they have to be spared.
        dialog.addEventListener('click', function (event) {
          if (event.target.closest('button') && !event.target.closest('[data-zoom-close]')) return;
          if (event.target.closest('.zoom__figure')) return;
          dialog.close();
        });

        // Leave the page showing whichever photo the visitor ended up on.
        dialog.addEventListener('close', function () {
          goTo(zoomIndex);
        });
      }

      /* ------------------------------------------------------------------
       * Sticky buy bar
       * ---------------------------------------------------------------- */

      var bar = document.querySelector('[data-buybar]');
      var buyBarObserver = null;

      function watchAddButton() {
        if (!bar || !('IntersectionObserver' in window)) return;

        var addButton = root.querySelector('[data-add-button]');
        if (!addButton) return;

        if (buyBarObserver) buyBarObserver.disconnect();

        buyBarObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              bar.classList.toggle('is-visible', show);
              bar.setAttribute('aria-hidden', show ? 'false' : 'true');
            });
          },
          { threshold: 0 }
        );

        buyBarObserver.observe(addButton);
      }

      watchAddButton();

      if (bar) {
        var barButton = bar.querySelector('[data-buybar-add]');
        if (barButton) {
          barButton.addEventListener('click', function () {
            var form = root.querySelector('form[data-cart-form]');
            if (form) form.requestSubmit();
          });
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (function () {
    function load(scope) {
      var holder = (scope || document).querySelector('[data-related]');
      if (!holder || holder.dataset.loaded === 'true') return;
      if (holder.querySelector('.product-grid')) return;

      holder.dataset.loaded = 'true';

      fetch(holder.getAttribute('data-url'))
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-related]');
          if (!fresh) return;

          holder.innerHTML = fresh.innerHTML;
          if (window.PlantzMotion) window.PlantzMotion.init(holder);
        })
        .catch(function () {
          /* Recommendations are a nicety: fail quietly. */
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { load(document); });
    } else {
      load(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      load(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
